import { Component, OnInit, OnDestroy, Input, Output,EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

import { NotificationInterface } from '@core/store/models/notifications.interface';

import { NotificationsService } from '@core/services/notifications/notifications.service';


@Component({
    selector: 'core-notifications-helpers-event-default-failed',
    templateUrl: './default-failed.component.html',
    styleUrls: ['./default-failed.component.scss']
})
export class CoreNotificationsHelpersEventDefaultFailedComponent implements OnInit, OnChanges {

    // EVENT_FAILED
    @Input() notification: NotificationInterface;

    constructor(private notsSrv: NotificationsService) {
    }

    ngOnInit(){
        console.log(" notification default failed item ",this.notification)
    }

    ngOnChanges(changes: SimpleChanges): void {
      if(changes.notification){
        console.log(" notification was updated ",this.notification)

      }
    }

    dismiss():void {
        this.notsSrv.dismissNotification(this.notification.id);
    }

}
